import crypto from "crypto-js";
import { KEY } from "../variables";

var encryptionKey = KEY.IDM_ENCRYPTION_KEY;

export async function encrypt(finalArr) {
  const arrayJsonString = JSON.stringify(finalArr);
  let ciphertext = crypto.AES.encrypt(arrayJsonString, KEY.ENCRYPTION_KEY).toString();
  return ciphertext;
}

export async function decrypt(url) {
  let decryptedObj = crypto.AES.decrypt(url, KEY.ENCRYPTION_KEY);
  let updatedDecryptedObj = decryptedObj.toString(crypto.enc.Utf8);
  const decryptedArray = JSON.parse(updatedDecryptedObj);
  return decryptedArray;
}

export const encryptIDM = (myDataObj) => {
  const myData = JSON.stringify(myDataObj);

  try {
    const enData = crypto.AES.encrypt(myData, encryptionKey).toString();
    return enData;
  } catch (err) {
    console.log(err);
  }
};

export const decryptIDM = (myData) => {
  try {
    var decryptedData = crypto.AES.decrypt(myData, encryptionKey);

    var decryptedDataParsed = JSON.parse(
      decryptedData.toString(crypto.enc.Utf8)
    );
  } catch (err) {
    console.log(err);
  }

  return decryptedDataParsed;
};